// Full-screen diagonally-tiled watermark. Non-interactive, non-selectable,
// prints as well thanks to the print media rules in index.css.

const LINE = "MVP PREVIEW · ROCKSTARS DIGITALS · UNPAID ";

export function PreviewWatermark() {
  const rows = Array.from({ length: 32 });
  const repeated = LINE.repeat(24);

  return (
    <div
      data-testid="preview-watermark"
      className="preview-watermark fixed inset-0 z-[9998] pointer-events-none select-none overflow-hidden"
      aria-hidden="true"
    >
      <div
        className="absolute -inset-1/2 flex flex-col gap-6"
        style={{ transform: "rotate(-30deg)", transformOrigin: "center" }}
      >
        {rows.map((_, i) => (
          <div
            key={i}
            className="whitespace-nowrap text-[18px] uppercase font-medium text-black/10 dark:text-white/[0.12]"
            style={{ letterSpacing: "0.15em" }}
          >
            {repeated}
          </div>
        ))}
      </div>
    </div>
  );
}
